"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactBootstrap = require("react-bootstrap");
var _reactRouterDom = require("react-router-dom");
var _excluded = ["name", "variant", "href", "target", "children", "icon", "svg", "link", "className", "type", "button", "as", "tooltip", "tooltipAlign", "loading", "title", "iconPosition"]; // @flow
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
//components
var ButtonElement = function ButtonElement(_ref) {
  var name = _ref.name,
    variant = _ref.variant,
    href = _ref.href,
    target = _ref.target,
    children = _ref.children,
    icon = _ref.icon,
    svg = _ref.svg,
    link = _ref.link,
    classNames = _ref.className,
    type = _ref.type,
    button = _ref.button,
    as = _ref.as,
    tooltip = _ref.tooltip,
    tooltipAlign = _ref.tooltipAlign,
    loading = _ref.loading,
    title = _ref.title,
    iconPosition = _ref.iconPosition,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var iconClass = !name && icon ? "shadow-none" : "";
  var className = "shadow-none btn btn-" + (variant || "none") + " " + (classNames || "");
  switch (as) {
    case "href":
      return /*#__PURE__*/_react.default.createElement("a", _extends({
        className: className + (!name && icon ? " p-0 " : "") + iconClass,
        variant: variant,
        href: href,
        target: target
      }, otherProps), name && /*#__PURE__*/_react.default.createElement("span", {
        title: title && title
      }, name), tooltip ? icon && tooltip && /*#__PURE__*/_react.default.createElement("span", null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.OverlayTrigger, {
        placement: "bottom",
        overlay: /*#__PURE__*/_react.default.createElement(_reactBootstrap.Tooltip, null, /*#__PURE__*/_react.default.createElement("span", {
          className: "text-start d-block"
        }, tooltip))
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "d-inline-block mx-1"
      }, icon))) : icon ? /*#__PURE__*/_react.default.createElement("span", {
        title: title && title
      }, icon) : "");
    case "link":
      return /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, _extends({
        className: className + " " + iconClass,
        variant: variant,
        to: link || ""
      }, otherProps), name && /*#__PURE__*/_react.default.createElement("span", null, name), tooltip ? icon && tooltip && /*#__PURE__*/_react.default.createElement("span", null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.OverlayTrigger, {
        placement: "bottom",
        overlay: /*#__PURE__*/_react.default.createElement(_reactBootstrap.Tooltip, null, /*#__PURE__*/_react.default.createElement("span", {
          className: "text-start d-block"
        }, tooltip))
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "d-inline-block mx-1"
      }, icon))) : icon ? /*#__PURE__*/_react.default.createElement("span", null, icon) : svg ? svg : "");
    case "text":
      return /*#__PURE__*/_react.default.createElement("span", otherProps, tooltip ? /*#__PURE__*/_react.default.createElement(_reactBootstrap.OverlayTrigger, {
        placement: "bottom",
        overlay: /*#__PURE__*/_react.default.createElement(_reactBootstrap.Tooltip, null, /*#__PURE__*/_react.default.createElement("span", {
          className: "text-start d-block"
        }, tooltip))
      }, /*#__PURE__*/_react.default.createElement("span", null, name)) : title ? /*#__PURE__*/_react.default.createElement("span", {
        title: title
      }, name) : /*#__PURE__*/_react.default.createElement("span", null, name));
    default:
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Button, _extends({
        variant: variant || "none",
        type: type,
        loading: !!(loading !== null && loading !== void 0 && loading.toString()) ? "false" : "true",
        className: " shadow-none " + classNames,
        title: title && title,
        "data-bs-toggle": "tooltip",
        "data-bs-placement": tooltipAlign === "right" ? "right" : "bottom"
      }, otherProps), iconPosition === "left" && /*#__PURE__*/_react.default.createElement("span", null, icon), name && /*#__PURE__*/_react.default.createElement("span", null, name), tooltip ? icon && tooltip && /*#__PURE__*/_react.default.createElement("span", null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.OverlayTrigger, {
        placement: tooltipAlign === "right" ? "right" : "bottom",
        overlay: /*#__PURE__*/_react.default.createElement(_reactBootstrap.Tooltip, null, /*#__PURE__*/_react.default.createElement("span", {
          className: "text-start d-block"
        }, tooltip))
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "d-inline-block mx-1"
      }, icon))) : icon && iconPosition !== "left" ? /*#__PURE__*/_react.default.createElement("span", null, icon) : svg ? svg : ""));
  }
};
var _default = ButtonElement;
exports.default = _default;